import { COLORS } from 'helpers/globals'

export default {
  Header: {
    background: COLORS.quaternary,
    paddingLeft: '.7rem',
    color: '#000'
  }
}



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/Header/style.js